import { Box, Typography, Chip } from '@material-ui/core'

export const TabLabel = ({
    label,
    count,
}: {
    label: string
    count: number | undefined
}) => {
    return (
        <Box
            component="span"
            display="flex"
            justifyContent="center"
            alignItems="center"
        >
            <Typography>{label}</Typography>
            {count && <Chip size="small" label={count} />}
        </Box>
    )
}
